import { AdminAcquirersScreen } from '@features/admin/ui/AdminAcquirersScreen'

export function AdquirentesPage() {
  return <AdminAcquirersScreen />
}
